module.exports = {"650203001":"天山路街道","650203002":"胜利路街道","650203003":"昆仑路街道","650203004":"银河路街道","650203005":"金龙镇街道","650203006":"五五新镇街道","650203200":"小拐乡","650203400":"农业开发区","650203506":"兵团一二九团","650203530":"兵团一三六团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650203.json
// module id = 2843
// module chunks = 0